import { fields } from 'iron-forge-react-modules';
import * as dataService from './dataService';



export type IShipItem = dataService.IShipItem;

export function genComponentAndControllerGenerator(subsidiaryId: string) {
  return fields.ObjectSelectField.genComponentAndControllerGenerator({
    useGetObjects: () => dataService.useQuery(subsidiaryId),
    fnGetObjectLabel: object => object.name
  });
}
